var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infinite-scroll-container"},_vm._l((_vm.videos),function(video,index){return _c('div',{key:index,staticClass:"video-wrapper"},[_c('video',{staticClass:"fullscreen-video",attrs:{"src":video.url,"controls":"","autoplay":"","muted":"","playsinline":""},domProps:{"muted":true}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }